export enum BOOKING_ROOM_STATUS {
    ACTIVE = "ACTIVE",
    DRAFT = "DRAFT"
}

export enum BOOKING_ROOM_DATE_TYPE {
    SINGLE_DAY = 'เฉพาะวัน',
    RANGE = 'เฉพาะช่วงวันที่',
}

export enum DAY_OF_WEEKS {
    MONDAY = 'จันทร์',
    TUESDAY = 'อังคาร',
    WEDNESDAY = 'พุธ',
    THURSDAY = 'พฤหัสบดี',
    FRIDAY = 'ศุกร์',
    SATURDAY = 'เสาร์',
    SUNDAY = 'อาทิตย์',
}

export const day_of_weeks_data = Object.values(DAY_OF_WEEKS)